module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-BOOSTER-GREEN-2.d1274530.jpg";